import { MenuModel } from "../../model/app/master";
import { EnumMenu } from "../../model/enums/enum-menu";

export const ModulosMock: MenuModel[] = [
  new MenuModel("Nova Leitura", EnumMenu.LEITOR, [], "/nova-leitura/camera", 1),
  new MenuModel("Histórico de Baixas", EnumMenu.HISTORICO, [], '/historico-baixas', 2),
  new MenuModel("Configurações", EnumMenu.CONFIGURACOES, [], '/configuracoes', 3),
]